export default __webpack_public_path__ + "static/media/4.34e7a6d4.svg";